import React, { useState } from 'react';
import AdvanceOptions from './components/AdvanceOptions';

const AdvancedOfferOptions = ({ eventId }: { eventId: string }) => {
  const [showAdvanceOptions, setShowAdvanceOptions] = useState(false);
  return (
    <div className="mt-10">
      {showAdvanceOptions ? (
        <AdvanceOptions
          setShowAdvanceOptions={setShowAdvanceOptions}
          eventId={eventId}
        />
      ) : (
        <div
          className="text-sm font-bold text-[#3853C4] cursor-pointer"
          onClick={() => setShowAdvanceOptions(true)}
        >
          Show advance options
        </div>
      )}
    </div>
  );
};

export default AdvancedOfferOptions;
